import TspApiService from "../../api/tspApiService";
import useTspApiResource from "../../hooks/useTspApiResource";

// Transforms backend teams + journey state into Bus Leader directory format
export function adaptLeadersData(teams = [], journeys = []) {
  return (teams || []).map((team) => {
    const teamJourneys = (journeys || []).filter(
      (j) => (j.team && String(j.team.id) === String(team.id)) || String(j.team_id) === String(team.id)
    );

    const activeJourney = teamJourneys.find((j) =>
      ["IN_PROGRESS", "IN_TRANSIT", "ARRIVED"].includes(j.status)
    );
    const upcomingJourney = teamJourneys.find((j) =>
      ["PLANNED", "APPROVED"].includes(j.status)
    );
    const completedJourneys = teamJourneys.filter(
      (j) => j.status === "COMPLETED"
    );

    let status = "available";
    let currentJourneyId = null;
    let currentJourneyName = "";
    let journeyState = "India";

    if (activeJourney) {
      status = "on-journey";
      currentJourneyId = activeJourney.id;
      currentJourneyName = activeJourney.journey_name || activeJourney.name || "";
      journeyState = activeJourney.state?.name || "India";
    } else if (upcomingJourney) {
      status = "upcoming";
      currentJourneyId = upcomingJourney.id;
      currentJourneyName = upcomingJourney.journey_name || upcomingJourney.name || "";
      journeyState = upcomingJourney.state?.name || "India";
    }

    const leaderName =
      team.leader?.name ||
      (team.leader_name ? team.leader_name : `${team.name} (Unassigned)`);

    return {
      id: team.id,
      name: leaderName,
      team: team.name,
      teamId: team.id,
      status,
      base: team.description || "Main Center",
      state: journeyState,
      currentJourneyId,
      currentJourneyName,
      journeysCompleted: completedJourneys.length,
      books: team.books_distributed || 0,
      rating: 5.0,
      phone: team.leader?.phone || "",
      email: team.leader?.email || "",
      memberCount: team.member_count || team.memberCount || 0,
    };
  });
}

// UI/API boundary for the Bus Leaders Directory.
// Uses real backend GET /api/tsp/teams and GET /api/tsp/journeys.
export default function useTspBusLeadersData() {
  const resource = useTspApiResource(
    async () => {
      const listTeamsFn = typeof TspApiService.listTeams === "function" ? TspApiService.listTeams() : Promise.resolve({ data: [] });
      const listJourneysFn = typeof TspApiService.listJourneys === "function" ? TspApiService.listJourneys({ limit: 100 }) : Promise.resolve({ data: [] });

      const [teamsRes, journeysRes] = await Promise.all([listTeamsFn, listJourneysFn]);
      const teams = teamsRes?.data || [];
      const journeys = journeysRes?.data || [];

      return {
        data: {
          leaders: adaptLeadersData(teams, journeys),
        },
      };
    },
    []
  );

  return {
    data: resource.data,
    loading: resource.loading && !resource.data,
    error: resource.error,
    reload: resource.reload,
  };
}
